import { useDiscountBannerCopy } from '@/hooks/useDiscountBannerCopy';

const DiscountBanner = () => {
  const { bannerCopy, displayDiscountBanner } = useDiscountBannerCopy();

  if (!displayDiscountBanner) {
    return null;
  }
  return (
    <div className="bg-gradient-to-r from-green-900 to-teal-500 px-6 py-6 text-center">
      <p className="text-white">{bannerCopy}</p>
      <p className="text-xs text-white">
        *discount will be applied at checkout for applicable scan types. No commission or affiliate
        fees are offered to the goodwill promoter of this discount.
      </p>
    </div>
  );
};

export default DiscountBanner;
